import { WhatsAppSendLimit } from 'modules/graphql';
import { WHATSAPP_SEND_LIMIT_MAPPER } from '../constants';

/**
 * Returns a message indicating the sender has hit their 24-hour message limit and is temporarily restricted.
 * The returned message may include specific information about the limit the sender has reached,
 * depending on the value of the `limit` parameter.
 *
 * @param limit WhatsAppSendLimit enum value indicating the limit the sender has reached.
 * @param hasMulitple boolean indicating whether multiple senders have reached their limits.
 * @returns string A message that indicates the current message sending restriction,
 * including the number of messages if the `limit` is provided, or a generic message if not.
 *
 * Example return:
 * {
 *  title: Sender restricted,
 *  description: "This sender has hit its 24-hour limit (100,000 messages) and is temporarily restricted. Messages sent from this sender will be skipped. You can still reply to ongoing conversations."
 * }
 *
 */

export function getWhatsAppSenderRestrictedWarningMessage(
  limit?: WhatsAppSendLimit,
  hasMulitple: boolean = false,
): {
  title: string;
  description: string;
} {
  if (hasMulitple)
    return {
      title: 'Sender restricted',
      description:
        'Multiple senders in this template have hit their 24-hour new conversation limit and are temporarily restricted. Messages sent from those senders will be skipped. You can still reply to ongoing conversations.',
    };
  const limitMessage = limit && WHATSAPP_SEND_LIMIT_MAPPER[limit];

  return {
    title: 'Sender restricted',
    description: `This sender has hit its 24-hour limit${limitMessage ? ` (${limitMessage})` : ''} and is temporarily restricted. Messages sent from this sender will be skipped. You can still reply to ongoing conversations.`,
  };
}
